import { Box, styled } from '@mui/material'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import TextInput from 'new-components/inputs/text-input'
import { useEffect, useState } from 'react'
import { ChromePicker } from 'react-color'
import Hue from 'react-color/lib/components/hue/Hue'
import { useTranslation } from 'react-i18next'

const BoxManageColor = styled(Box)(({ theme }) => ({
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: '0px 10px 15px 0px rgba(31, 41, 55, 0.10), 0px 0px 6px 0px rgba(31, 41, 55, 0.05)',
    position: 'absolute',
    zIndex: 1,
    borderRadius: '8px',
    marginTop: '1px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '.content-select-color': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        '.chrome-picker': {
            borderRadius: '4px !important',
            boxShadow: 'none !important',
            overflow: 'hidden'
        },
        '.chrome-picker div:nth-child(2)': {
            padding: '0px !important',
            '.flexbox-fix': {
                display: 'none !important'
            }
        },
        '.hue-picker ': {
            width: "100% !important",
            '.hue-horizontal': {
                borderRadius: '8px !important',
                'div div': {
                    border: '3px solid #fff',
                    backgroundColor: 'transparent !important'
                }
            }
        }
    }
}))

export type FormManageColorProps = {
    color: string
    setColor: (value: string) => void
    handleChangeColor: ({ hex }: { hex: string }) => void
    onLoadOperativeType: (search: string) => void
    operativeTypes: any
    operativeType: any
    handleChangeOperative: (val: any) => void
    disabledTextInput?: boolean
}

const FormManageColor = (props: FormManageColorProps) => {
    const { color, setColor, handleChangeColor, onLoadOperativeType,
        operativeTypes, operativeType, handleChangeOperative } = props
    const { t } = useTranslation()

    const [renderColor, setRenderColor] = useState<string>('')

    useEffect(() => {
        if (color.includes('#')) {
            setRenderColor(color.slice(1))
        } else {
            setRenderColor(color)
        }

    }, [color])

    return (
        <BoxManageColor>
            <Box className={`content-select-color`}>
                <ChromePicker color={color} onChange={handleChangeColor} />
                <Hue color={color} onChange={handleChangeColor} />
                <Box display='flex' alignItems='center' gap='8px' >
                    <Box sx={{ '.MuiInputBase-root': { height: '43px' } }}> {'HEX'}</Box>
                    <Box sx={{ '.MuiInputBase-input': { padding: "0 1rem 0 .4rem !important" }, }}>
                        <TextInput
                            value={renderColor}
                            onChange={(e) => {
                                handleChangeOperative(e.target.value)
                                const newValue = e.target.value
                                setColor(`#${newValue}`)
                            }}
                            inputProps={{ startAdornment: <Box>#</Box> }}
                            placeholder={t('รหัส สี Tag')}
                        />
                    </Box>
                </Box>
            </Box>
            {!props.disabledTextInput &&
                <Box>
                    <Box color={'#808080'}> {t('TAGS.FORM.OPERATIVECOLOR')} </Box>
                    <Box sx={{ '.MuiInputBase-root': { height: '43px', paddingRight: '30px !important' } }}>
                        <AutocompleteSelect
                            labelId='select-color'
                            options={operativeTypes}
                            getOptionLabel={(option) => option?.operativeTypeName || ''}
                            renderOption={((props: any, option: any) => {
                                return (<Box {...props}>{option?.operativeTypeName || ''} </Box>)
                            })}
                            value={operativeType || ''}
                            onchange={(e, value) => {
                                handleChangeOperative(value)
                                if (value?.color && value?.color !== '') {
                                    setColor(value?.color)
                                }
                            }}
                            noOptionsText={t('NOT_FOUND')}
                            onInputChange={(event, val) => {
                                if (event) { onLoadOperativeType(val) }
                            }}
                            onOpen={() => onLoadOperativeType('')}
                            onClose={() => onLoadOperativeType('')}
                        />
                    </Box>
                    <Box sx={{
                        marginTop: '8px',
                        height: '43px',
                        borderRadius: '4px',
                        border: '1px solid #0000001f',
                        backgroundColor: color || 'transparent'
                    }} />
                </Box>
            }
        </BoxManageColor>
    )
}

export default FormManageColor